  const imgs = document.querySelectorAll('.pay_type_pic');

  if (imgs.length) {
    const closeDom = document.getElementsByClassName('pay-fixed-close')[0];
    const payFixedDom = document.getElementsByClassName('pay-fixed')[0];
    const body = document.body;
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].onclick = function () {
        payFixedDom.classList.remove('hide-fiexed');
        scrollTop = body.scrollTop;
        body.style.overflow = 'hidden';
        body.style.height = '100vh';
      };
    }

    closeDom.onclick = function () {
      payFixedDom.classList.add('hide-fiexed');
      body.scrollTop = scrollTop;
      body.style.overflow = 'auto';
      body.style.height = 'auto';
    };
  }